<template>
  <div class="index-detail">
    <comTop></comTop>
      <el-row class="detail_top">
         <el-col :span="6">&nbsp;</el-col>
         <el-col :span="12">
           <div class="detail_top_box">
             <h1>{{query.title}}</h1>
             <p class="p1">发布于：{{query.modifyTimes}}</p>
             <img :src="query.pictureUrl" alt="">
             <!-- <p class="p2">{{query.content}}</p> -->
             <div v-html="query.content"></div>
           </div>
         </el-col>
         <el-col :span="6">&nbsp;</el-col>
         
      </el-row>
      <el-row class="detail_btm">
        <comFooter></comFooter>
      </el-row>
  </div>
</template>
<script>
import comTop from "@/components/page/comTop.vue"; //头部
import comFooter from "@/components/page/comFooter.vue"; //脚部
export default {
  components: {
    comFooter,
    comTop
  },
  data() {
    return {
      query: this.$route.query,
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created(){
    console.info(this.$route.query)
  },
};
</script>
<style>
  .index-detail{
    background: #ffffff;
  }
  .detail_top_box img{
    width: 650px;
    /* height: 467px; */
  }
  .detail_top_box .p1{
    font-size:12px;
    font-family:Helvetica;
   color:rgba(77,76,80,1);
  }
  .detail_top_box .p2{
   color:rgba(77,76,80,1);
   white-space: normal;
    word-break: break-all;
  }
  /* .detail_top{
    position: relative;
  }
  .detail_btm{
    position: absolute;
    bottom: 0;
  } */
</style>


// WEBPACK FOOTER //
// src/components/page/detail.vue